import type { Shortcut } from './types'

function isAppleDevice() {
  return import.meta.client && /Mac|iPhone|iPad|iPod/.test(navigator.userAgent)
}

export function resolveKeyLabel(key: string): string {
  switch (key) {
    case 'altKey':
      return isAppleDevice() ? '⌥ option' : 'Alt'
    case 'metaKey':
      return isAppleDevice() ? 'Cmd' : 'Win'
    case 'shiftKey':
      return 'Shift'
    case 'ctrlKey':
      return 'Ctrl'
    default:
      return key.toUpperCase()
  }
}

export function resolveKeyAriaLabel(key: string): string {
  if (key === 'altKey' && isAppleDevice()) {
    return 'option'
  }

  return resolveKeyLabel(key)
}

export function getShortcutKeys(shortcut: Shortcut): string[] {
  return [...shortcut.modifiers, ...shortcut.keys]
}

export function getShortcutAriaLabel(shortcut: Shortcut): string | undefined {
  const keys = getShortcutKeys(shortcut).map(resolveKeyAriaLabel)

  return keys.length > 0 ? `${shortcut.label} (${keys.join(' + ')})` : undefined
}
